// DEV-ONLY: watch an engine-2 (grid x2 + frames x2) game in the real viewer.
// Static frames from engine2 (no backend/DB). Route: /dev/engine2.
// Safe to delete together with its route in App.jsx and src/devEngine2Game.json.
import GamePlayer from "../components/GamePlayer";
import game from "../devEngine2Game.json";

export default function DevEngine2Page() {
  const h = typeof window !== "undefined" ? window.innerHeight : 800;
  return (
    <div style={{ minHeight: "100vh", background: "#0b1220",
                  display: "flex", flexDirection: "column",
                  alignItems: "center", gap: 8, padding: 12 }}>
      <div style={{ color: "#cbd5e1", fontFamily: "system-ui", fontSize: 14 }}>
        ENGINE 2 (grid×2 + frames×2) — seed 0 — score {game.score[0]}–{game.score[1]} — {game.frames.length} frames
        &nbsp;·&nbsp; use the 2×/3× speed button (match is twice as many frames)
      </div>
      <GamePlayer
        frames={game.frames}
        localColor="#e07b00"
        awayColor="#3b82f6"
        vertical
        autoPlay
        maxHeight={Math.round(h - 96)}
      />
    </div>
  );
}
